import { useState } from "react";

const faqs = [
  {
    question: "玫瑰视频是什么？",
    answer: "玫瑰视频是一个汇集香蕉视频、糖豆视频、小蓝视频、蓝莓视频等热门影视资源的在线平台，提供高清免费在线观看服务，涵盖电视剧全集、电影大全、综艺、动漫等多种类型内容。",
  },
  {
    question: "玫瑰视频需要付费吗？",
    answer: "不需要！玫瑰视频上的所有影视资源均免费在线观看，无需注册，无需付费，打开即可畅享高清影视内容。",
  },
  {
    question: "支持哪些设备观看？",
    answer: "玫瑰视频支持在电脑、平板、手机等多种设备上观看。无论是Windows、Mac、iOS还是Android系统，打开浏览器访问我们的网站即可流畅观看。",
  },
  {
    question: "影视资源更新频率如何？",
    answer: "我们每日更新大量影视资源，包括最新电视剧、热门电影、综艺节目和动漫番剧。通常新剧集上线后24小时内即可在平台观看。",
  },
  {
    question: "视频画质怎么样？有缓冲吗？",
    answer: "玫瑰视频所有资源均提供高清画质（720P/1080P），部分热门内容支持超高清4K。我们采用先进的CDN加速技术，确保播放流畅不缓冲。",
  },
  {
    question: "香蕉视频、糖豆视频、小蓝视频、蓝莓视频有什么区别？",
    answer: "这四个平台各有特色——香蕉视频主打热门电视剧，糖豆视频侧重电影大片，小蓝视频以综艺和动漫见长，蓝莓视频拥有丰富的纪录片和少儿内容。在玫瑰视频您可以一站式浏览所有平台的优质资源。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于玫瑰视频，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}